// This file configures the initialization of Sentry on the browser.
// The config you add here will be used whenever a page is visited.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

import { init } from "@sentry/nextjs";

const SENTRY_DSN = process.env.SENTRY_DSN || process.env.NEXT_PUBLIC_SENTRY_DSN;

init({
  dsn: SENTRY_DSN || "https://ea1bb2610e8d42a98c5f34623fbede5e@o499996.ingest.sentry.io/4504133491032064",
  environment: process.env.NEXT_PUBLIC_FOODY_ENV,
  // Adjust this value in production, or use tracesSampler for greater control
  tracesSampleRate: 0.0,
  // ...
  // Note: if you want to override the automatic release value, do not set a
  // `release` value here - use the environment variable `SENTRY_RELEASE`, so
  // that it will also get attached to your source maps
  // eslint-disable-next-line no-unused-vars
  beforeSend(event) {
    return null;
  },
});
